export const LANGS = [["en", "English"], ["fr", "Français"]];

export const getLang = () => {
  const l = localStorage.getItem("cias_lang");
  return LANGS.some(([k]) => k === l) ? l : "en";
};

export const setLang = (l) => {
  localStorage.setItem("cias_lang", l);
  window.location.reload();
};

const FR = {
  "My path": "Mon parcours",
  Learn: "Apprendre",
  Readiness: "Maturité",
  Certificates: "Certificats",
  Capstone: "Projet final",
  Admin: "Admin",
  "Home page": "Accueil",
  Home: "Accueil",
  level: "niveau",
  "Read the lesson": "Lire la leçon",
  "Watch the video": "Voir la vidéo",
  Next: "Suivant",
  Back: "Retour",
  "Previous lesson": "Leçon précédente",
  "Finish lesson": "Terminer la leçon",
  "Next lesson": "Leçon suivante",
  "Review and finish": "Révision et fin",
  Review: "Révision",
  Step: "Étape",
  of: "sur",
  Lesson: "Leçon",
  Done: "Terminé",
  "Practice questions": "Questions d’entraînement",
  "Try 5 questions": "Essayer 5 questions",
  "practice-card": "5 questions sur cette leçon. Aucune note n’est gardée. Touchez « Voir la réponse » pour vérifier une question, ou voyez toutes les réponses à la fin.",
  "Read the text for this part": "Lire le texte de cette partie",
  "No video for this part yet. Read the text below.": "Pas encore de vidéo pour cette partie. Lisez le texte ci-dessous.",
  "Try it": "Essayez",
  Question: "Question",
  "Show answer": "Voir la réponse",
  "Finish quiz": "Terminer le quiz",
  "Next question →": "Question suivante →",
  "See result": "Voir le résultat",
  Correct: "Correct",
  "Not quite. The best answer is": "Pas tout à fait. La meilleure réponse est",
  "Review your answers": "Revoir vos réponses",
  "Correct answer": "Bonne réponse",
  "Your answer": "Votre réponse",
  "learn-sub": "8 modules sur 3 jours. Terminez les leçons, puis réussissez le contrôle du module avec 8 sur 10.",
  Day: "Jour",
  See: "Voir",
  Design: "Concevoir",
  Deploy: "Déployer",
  Start: "Commencer",
  Continue: "Continuer",
  "Module quizzes →": "Quiz du module →",
  Glossary: "Glossaire",
  "glossary-sub": "Des mots simples pour les termes des leçons.",
  "Search words": "Rechercher un mot",
  "Say it simply": "En termes simples",
  Example: "Exemple",
  "mt-banner": "Traduction automatique, en cours de révision. En cas de doute, la version anglaise fait foi.",
  Language: "Langue",
  "mt-short": "Traduction automatique, en cours de révision",
  "No matching words.": "Aucun mot trouvé.",
  "Change level": "Changer de niveau",
  "Think first": "Réfléchissez d’abord",
  "Show the answer": "Voir la réponse",
  "Running case": "Cas suivi",
  "You will be able to": "Vous saurez",
  "Key terms": "Mots clés",
  "Through your lens": "Selon votre rôle",
  "Your role": "Votre rôle",
  "Plant and operations leaders": "Responsables d’usine et d’exploitation",
  Engineers: "Ingénieurs",
  "OT/IT and data leads": "Responsables OT/IT et données",
  "Digital and CI managers": "Responsables digital et amélioration continue",
  Executives: "Dirigeants",
  "Your plant project": "Votre projet d’usine",
  "See your whole project": "Voir tout votre projet",
  "Video coming": "Vidéo à venir",
  "Switch to Text mode": "Passer en mode texte",
  "Storyboard (admins only)": "Storyboard (admins seulement)",
  "Text mode": "Mode texte",
  "Video mode": "Mode vidéo",
  "Text or video": "Texte ou vidéo",
  "Now do the interactive lab": "Faites maintenant l’atelier interactif",
  "lab-card": "Cet atelier est obligatoire. Le terminer valide cette leçon.",
  "Start the lab": "Commencer l’atelier",
  "Badge earned": "Badge obtenu",
  Badge: "Badge",
  "credential-note": "Ceci est un certificat de formation. Ce n’est ni une licence d’ingénieur, ni un certificat de sécurité, ni une autorisation d’utiliser ou de modifier quoi que ce soit dans une usine.",
  "project-intro": "Chaque leçon se termine par une étape pour votre propre usine. Les étapes forment votre canevas d’opportunité et votre note de pilote.",
  "project-dash": "Chaque leçon se termine par une étape pour votre propre usine. Voyez toutes les étapes déjà faites.",
  Practice: "Entraînement",
  Certified: "Certifié",
  Diagnostic: "Diagnostic",
  "placement only": "positionnement seulement",
  easy: "facile",
  medium: "moyen",
  hard: "difficile",
  "Show hint": "Voir l’indice",
  Hint: "Indice",
  "Hint lesson": "Leçon de l’indice",
  "a correct answer then earns": "une bonne réponse rapporte alors",
  marks: "points",
  "Review this lesson →": "Revoir cette leçon →",
  Lab: "Atelier",
  "Answer recorded.": "Réponse enregistrée.",
  result: "résultat",
  "correct": "correctes",
  "raw accuracy": "précision brute",
  "supported score": "score avec aide",
  "hints used on": "indices utilisés sur",
  Placement: "Positionnement",
  "placement-note": "Votre parcours commence quand même au niveau Foundation ; le seuil de 80 % ne change jamais.",
  "You met the 80% standard": "Vous avez atteint le seuil de 80 %",
  " — the next module is unlocked.": " — le module suivant est débloqué.",
  "below-standard": "Vous êtes sous le seuil de certification de 80 % pour ce module. Revoyez les leçons indiquées, puis refaites une tentative avec un autre jeu de questions.",
  "repeat-course": "Statut : reprendre le cours. Votre progression dans ce niveau a été remise à zéro — relisez toutes les leçons à partir du module 1, puis passez de nouvelles tentatives certifiées.",
  "capstone-open": "Les huit modules Strategist sont réussis. Le projet final est maintenant ouvert.",
  "admin-preview": "Aperçu admin : niveau terminé, mais aucun certificat n’est délivré pour les comptes admin.",
  "View your certificate": "Voir votre certificat",
  "Remediation areas": "Points à revoir",
  "Back to lesson": "Retour à la leçon",
  "Back to my path": "Retour à mon parcours",
  "Back to module": "Retour au module",
};

export const t = (key) => (getLang() === "fr" ? FR[key] ?? key : key);

export const FR_VALUES = new Set(Object.values(FR));

export const colon = () => (getLang() === "fr" ? " :" : ":");

export const tierLevel = (label) => (getLang() === "fr" ? `Niveau ${label}` : `${label} level`);
